import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calculator, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import api from '@/lib/api';
import { toast } from 'sonner';

function FinancasLogin() {
  const [empresas, setEmpresas] = useState([]);
  const [empresaId, setEmpresaId] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('financas_token')) {
      navigate('/financas/dashboard', { replace: true });
      return;
    }
    api.get('/financas/auth/empresas').then(({ data }) => setEmpresas(data)).catch(() => {});
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!empresaId) { toast.error('Selecione uma empresa'); return; }
    setLoading(true);
    try {
      const { data } = await api.post('/financas/auth/login', { username, password, empresa_id: empresaId });
      localStorage.setItem('financas_token', data.access_token);
      localStorage.setItem('financas_user', JSON.stringify(data.user));
      localStorage.setItem('financas_empresa', JSON.stringify(data.empresa));
      toast.success(`Bem-vindo, ${data.user.nome}!`);
      navigate('/financas/dashboard');
    } catch {
      toast.error('Credenciais inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-950 via-slate-900 to-emerald-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white/5 backdrop-blur-xl rounded-2xl p-8 border border-emerald-500/20 shadow-2xl">
          <div className="text-center mb-8">
            <div className="w-20 h-20 bg-gradient-to-br from-emerald-400 to-emerald-700 rounded-2xl mx-auto flex items-center justify-center mb-4 shadow-xl shadow-emerald-500/30">
              <Calculator className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">Financeiro MEI/ME</h1>
            <p className="text-emerald-200/70">Gestão Financeira Inteligente</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label className="text-emerald-100 text-sm">Empresa / Loja</Label>              <Select value={empresaId} onValueChange={setEmpresaId}>
                <SelectTrigger data-testid="financas-empresa-select" className="bg-white/5 border-white/10 text-white">
                  <SelectValue placeholder="Selecione sua empresa" />
                </SelectTrigger>
                <SelectContent className="bg-slate-900 border-white/10 text-white">
                  {empresas.length === 0 ? (
                    <div className="px-3 py-4 text-sm text-slate-400">Nenhuma empresa cadastrada. Peça ao admin master.</div>
                  ) : empresas.map(e => (
                    <SelectItem key={e.id} value={e.id}>{e.nome}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-emerald-100 text-sm">Usuário</Label>
              <Input
                data-testid="financas-username-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="bg-white/5 border-white/10 text-white placeholder:text-white/40"
                placeholder="Seu usuário"
                required
              />
            </div>
            <div>
              <Label className="text-emerald-100 text-sm">Senha</Label>
              <Input
                data-testid="financas-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-white/5 border-white/10 text-white placeholder:text-white/40"
                placeholder="Sua senha"
                required
              />
            </div>

            <Button
              data-testid="financas-login-btn"
              type="submit"
              disabled={loading}
              className="w-full bg-gradient-to-r from-emerald-500 to-emerald-700 hover:from-emerald-600 hover:to-emerald-800 text-white font-semibold py-6 shadow-lg shadow-emerald-500/30"
            >
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'ENTRAR'}
            </Button>
          </form>
        </div>
        <p className="text-center text-emerald-300/40 text-xs mt-6">Sistema Financeiro Profissional</p>
      </div>
    </div>
  );
}

export default FinancasLogin;
